import {Module} from 'vuex';
import {RootState} from '@/types';
import {namespace} from 'vuex-class';
import BannerApi from '@/api/BannerAPI';

export const jobsModule = namespace('jobs');
export interface Jobs {
  [key: string]: any;
}

interface JobState {
  jobs: Jobs[];
  category: Jobs[];
  jobStatus: Jobs[];
  job: Jobs | null;
  point: Jobs | 0;
  expire: Jobs | 0;
  quizSetting: [];
}
export default <Module<JobState, RootState>>{
  namespaced: true,
  state: {
    jobs: [],
    category: [],
    jobStatus: [],
    job: null,
    point: 0,
    expire: 0,
    quizSetting: [],
  },
  actions: {
    async getBanner(_, params = {}) {
      try {
        const {data} = await BannerApi.getBanner(params);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
  },
};
